import { render, staticRenderFns } from "./SubmissionComplete.vue?vue&type=template&id=d71bf1fc&scoped=true&"
import script from "./SubmissionComplete.vue?vue&type=script&lang=js&"
export * from "./SubmissionComplete.vue?vue&type=script&lang=js&"
import style0 from "./SubmissionComplete.vue?vue&type=style&index=0&id=d71bf1fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d71bf1fc",
  null
  
)

export default component.exports